import { createTheme, adaptV4Theme } from "@mui/material/styles";

import palette from "theme/palette";
import typography from "theme/typography";
import overrides from "theme/overrides";

const baseTheme = {
  palette,
  typography,
  //overrides, TODO
};

export const theme = createTheme(adaptV4Theme(baseTheme));
